import { AdminTemplateCopy } from './AdminTemplateCopy';

export default AdminTemplateCopy;